import { useStoryStore } from '@/features/shared/stores/story.store'
import { $createTextNode, LexicalNode, ParagraphNode } from 'lexical'
import { nanoid } from 'nanoid'
import { useEffect } from 'react'
import { ParaNode } from '../nodes/ParaNode'

const StParaTransformPlugin = () => {
    const { editor } = useStoryStore()

    useEffect(() => {
        if (!editor) return

        return editor.registerNodeTransform(ParagraphNode, (node: LexicalNode) => {
            console.log('transform', node.getType(), node)
            if (!(node instanceof ParaNode)) {
                const newNode = ParaNode.create(nanoid())
                if (node instanceof ParagraphNode) {
                    newNode.append($createTextNode(node.getTextContent()))
                }
                node.replace(newNode)
                newNode.selectStart()
            }
        })
    }, [editor])

    return null
}

export default StParaTransformPlugin
